import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-profile-splash',
  templateUrl: './profile-splash.component.html',
  styleUrls: ['./profile-splash.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule]
})
export class ProfileSplashComponent {
  @Output() dismissed = new EventEmitter<void>();

  readonly steps = [
    { icon: 'person', label: 'Personal Profile' },
    { icon: 'badge', label: 'Driver License' },
    { icon: 'work', label: 'Employment History' },
    { icon: 'home', label: 'Residence History' },
    { icon: 'local_shipping', label: 'Driving Experience' },
    { icon: 'car_crash', label: 'Accident Records' },
    { icon: 'gavel', label: 'Traffic Convictions' },
  ];

  onLetsGo(): void {
    this.dismissed.emit();
  }
}
